import { range } from 'lodash'
import { format, startOfMonth, addMonths, subMonths, differenceInCalendarMonths } from 'date-fns'
import router from '@/router'
import spRouter from '@/pages/sp/router'

export default {
  namespaced: true,
  state: {
    conditions: {
      unit: 0,
      startTerm: '',
      endTerm: '',
      timeZone: 0,
      statusType: 0,
      type: 0,
    },
    betweenDates: [],
  },
  mutations: {
    set(state, data) {
      state.conditions = data.conditions
      state.betweenDates = data.betweenDates
    },
    update(state, data) {
      state.conditions = { ...state.conditions, ...data }
    },
  },
  getters: {
    isBetween(state) {
      return [1, 3, 4].includes(state.conditions.unit)
    },
    query({ conditions }, { isBetween }) {
      return {
        ...conditions,
        startTerm: isBetween ? conditions.startTerm : conditions.endTerm,
      }
    },
  },
  actions: {
    start({ commit, rootState }, { defaultUnit }) {
      const baseDate = startOfMonth(new Date())
      const baseStartTerm = subMonths(baseDate, 2)
      const baseEndTerm = addMonths(baseDate, 12)

      // サービス開始時の年月
      // 一つ多く配列が欲しいので-2（0 = 2018/10 , -1 = 0 = 2018/09）
      const serviceStartDate = new Date(2018, 9 - 2)
      const betweenDates = range(differenceInCalendarMonths(baseEndTerm, serviceStartDate)).reduce(
        (accumulator, _, idx) => [...accumulator, subMonths(baseEndTerm, idx)],
        [],
      )
      const query = rootState.app.isSP ? spRouter.currentRoute.query : router.currentRoute.query
      const { unit: routeUnit, startTerm, endTerm, timeZone, statusType, type } = query

      const unit = defaultUnit || routeUnit
      commit('set', {
        conditions: {
          unit: unit ? Number(unit) : 2,
          startTerm: format(startTerm || baseStartTerm, 'YYYY-MM'),
          endTerm: format(endTerm || baseDate, 'YYYY-MM'),
          timeZone: timeZone ? Number(timeZone) : 0,
          statusType: statusType ? Number(statusType) : 0,
          type: type ? Number(type) : 0,
        },
        betweenDates,
      })
    },
  },
}
